import DepositModal from './components/DepositModal';
import './styles/globals.css';

function App() {
  return (
    <div className="App">
      <DepositModal isOpen={true} onClose={() => {}} />
    </div>
  );
}

export default App;
